const socialShareTarget = '[data-social-share]';
const currentUrl = window.location.href;
const encodedUrl = encodeURIComponent(currentUrl);
const WINDOW =
	'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=500, height=500';

const ESocialType = {
	FACEBOOK: 'facebook',
	TWITTER: 'twitter',
	LINKEDIN: 'linkedin',
	INSTAGRAM: 'instagram',
	LINK: 'link',
};

export function initSocialShare() {
	const $socialShare = $(socialShareTarget);
	$socialShare.on('click', function () {
		const $element = $(this);
		// get type of social share
		const type = $element.data('social-type');
		if (type) {
			switch (type) {
				case ESocialType.FACEBOOK:
					openSocialShareFacebook();
					break;
				case ESocialType.TWITTER:
					openSocialShareTwitter();
					break;
				case ESocialType.LINKEDIN:
					openSocialShareLinkedin();
					break;
				case ESocialType.LINK:
					openSocialShareLink();
					break;
				default:
					return null;
			}
		}
	});
}

function openSocialShareFacebook() {
	window.open(`https://www.facebook.com/sharer.php?u=${encodedUrl}`, 'targetWindow', WINDOW);
}

function openSocialShareTwitter() {
	let url = `http://twitter.com/share?url=${encodedUrl}&hashtags=StoryIQ`;
	window.open(url, 'targetWindow', WINDOW);
}

function openSocialShareLinkedin() {
	let url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
	window.open(url, 'targetWindow', WINDOW);
}

function openSocialShareLink() {
	let $temp = $('<input>');
	$('body').append($temp);
	$temp.val(currentUrl).select();
	document.execCommand('copy');
	$temp.remove();
	$('.social_share-success').css('opacity', '1');

	setTimeout(function () {
		$('.social_share-success').css('opacity', '0');
	}, 4000);
	// initToast(EToastType.COPY_SUCESS);
}



// WEBPACK FOOTER //
// ./scripts/components/socialShare.ts